const buildThumborUrl = ({ src, width, quality, format }) => {
  const filters = [
    `quality(${quality || 90})`,
    ...(format ? [`format(${format})`] : []),
  ];
  const params = [`${width}x0`, `filters:${filters.join(":")}`];
  return src.toLowerCase().endsWith("svg")
    ? src
    : `https://thumbor.aleksundshantu.net/unsafe/${params.join("/")}/${encodeURIComponent(src)}`;
};

export default function thumborLoader({ src, width, quality }) {
  return buildThumborUrl({ src, width, quality });
}

/**
 * Same as the default loader, but re-encodes to AVIF (use in `<source type="image/avif">`).
 * @param {import("next/image").ImageLoaderProps} props
 */
export function thumborAvifLoader({ src, width, quality }) {
  return buildThumborUrl({ src, width, quality, format: "avif" });
}
